import classNames from 'classnames';
import styles from './FJHoverBoardGradation.module.less';
import React from 'react';
import FJUtil from '../../../util/FJUtil';

const FJHoverBoardGradation = React.forwardRef((props, ref) => {
    // isShowInBorder 是否显示内边框
    const {
        active,
        children,
        borderRadius = 10,
        isShowInBorder = false,

        className,
        contentClassName,
        style,

        onClick,
        onMouseEnter,
        onMouseLeave,
        selectBgColor = '#f3f3f7',
        hasHover = !FJUtil.isMobile(),
    } = props;

    return (
        <div
            ref={ref}
            className={classNames(styles.box, className, active && styles.active, hasHover && styles.hover)}
            style={{
                ...style,
                '--border-radius': borderRadius + 'px',
                '--border-content-radius': borderRadius - 2 + 'px',
            }}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {isShowInBorder && <div className={styles.in_border}></div>}
            <div
                className={classNames(
                    styles.content,
                    isShowInBorder && styles.show_in_border,
                    active && isShowInBorder && styles.show_in_border_active,
                    contentClassName,
                )}
                style={{ '--select-bg-color': selectBgColor }}
            >
                {children}
            </div>
        </div>
    );
});

export default FJHoverBoardGradation;
